/* eslint-disable @typescript-eslint/naming-convention */
export interface RequestedClassDto {
  ID: string;
  Name: string;
  GroupType: string;
  /** WI 34684: the class's VP ClassCode values; sent only by api/manpowers/requestedClasses. */
  Codes?: string[] | null;
}
